import './assets/less/screen.less'


function setRem() {
  // 设计稿宽度，比如你设计稿是 1920px
  const designWidth = 1920
  // 基准字体大小，比如 16px
  const baseSize = 16

  // 当前屏幕宽度 / 设计稿宽度 = 缩放比例
  const scale = document.documentElement.clientWidth / designWidth

  // 设置根元素字体大小
  document.documentElement.style.fontSize = baseSize * scale + 'px'
}

// 初始化
setRem()
// 监听窗口变化
window.addEventListener('resize', setRem)

import Vue from 'vue'
import VueScroll from 'vuescroll'
import router from './router' // 引入 router 文件夹下的 index.js
import store from './store/index'
import util from './utils/index'
import App from './App.vue'
import './config/filters'
import './config/directives'
import ViewUI from 'view-design';
import './assets/styles/main.css' // 引入全局样式

Vue.use(ViewUI);

Vue.use(VueScroll)
Vue.config.productionTip = false
Vue.prototype.util = util

var vue = new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
export default vue
